import { Component, OnInit, Input } from '@angular/core';
import { Header } from 'src/app/shared/components/header/header.model';
import { DetailsOfCreditor, CreditorContact, UserAccountDetails, EngagementDetails, UserContact, UserRole, CreditorDetailsList, ClaimantTypeEnum } from './user-profile.model';
import { DataService } from 'src/app/core/data.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { UtilitiesService } from 'src/app/core/utilities.service';
 
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { _fixedSizeVirtualScrollStrategyFactory } from '@angular/cdk/scrolling';
import { FloatMessageService } from 'src/app/shared/services/float-message.service';
import { FieldLength } from 'src/app/shared/general/field-length';
import { timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  registerForm: UntypedFormGroup;
  detailsOfUsers: DetailsOfCreditor = new DetailsOfCreditor();
  userAccount: UserAccountDetails = new UserAccountDetails();
  userRole: UserRole = new UserRole();
  engagemetList: any[];
  creditorList: any[];
  engagementName: string = null;
  userContactList: any[];
  showIndividualForm = false;
  hardcopy = false;
  showCompanyForm = false;
  creditorContact: CreditorContact = new CreditorContact();
  labelCaption: any;
  userId: any = null;
  emailId: any;
  creditorId: any = null;
  roleName: any;
  checked: boolean = true;
  accountmanager: boolean;
  creditordetails: any;
  checkBoxProperty: boolean;
  deliveryModevalue: boolean = false;
  isFieldDisabled:boolean;
  isSave: boolean;
  isCreditorSelected: boolean;
  engagementId: any;
  userDetails: any;
  isActivatedUser: boolean=true;
  lockScreen:Boolean= false;
  editLockTimer:any;
  fieldLength = FieldLength;
  loginUserId:any;
  iseditPage:boolean = false;
  editLockedBy:any = null;

  @Input('label-caption') set _labelCaption(val) {
    this.labelCaption = val;
  }

  jsonData: any = {
    
  };
  title = 'kpmg-advent';
  headerData: Header = new Header();
  constructor(private dataService: DataService, private formBuilder: UntypedFormBuilder, private activatedRoute: ActivatedRoute,
    private utilitiesService: UtilitiesService,private router: Router,public dialog: MatDialog,
    private spinnerService: NgxSpinnerService, private floatMessage: FloatMessageService) {
    this.headerData.isHeaderRight = true;
    //this.headerData.isSubHeader = true;
    //this.headerData.headTwo = "MY ACCOUNT";
  }

  ngOnInit() {
      
    this.userId = sessionStorage.getItem('userId');
    this.emailId = sessionStorage.getItem('emailId');
    let data = this.utilitiesService.GetLabelCaption(
      this.activatedRoute.snapshot.data.labelCaptionData,
      'Module_UserProfile'
    );
    if (data && data['Label']) {
      this.labelCaption = data['Label'];
    }
    this.registerForm = this.formBuilder.group({
      userfirstName: ['',],
      userlastName: ['',],
      useremail: ['',],
      usercountryCode: ['',],
      usercontactNumber: ['',],
      name: ['',],
      lastName: ['',],
      nRICFINPassportNo: ['',],
      uen: ['',],
      postalAddress: ['',],
      country: ['',],
      country2: ['',],
      contactNumber: ['',],
      postalCode: ['',],
      postalCode2: ['',],
      correspondanceAddress: ['',],
      countryCode: ['',],
      email: ['',],
      engagementlist: ['',],
      creditorlist: ['',]
    });
    this.getUserDetails();
    this.getUserRole();
    if (this.detailsOfUsers.creditorContact.length > 0) {
      this.registerForm.patchValue({
        contactNumber: this.detailsOfUsers.creditorContact[0]
          .contactNumber,
        countryCode: this.detailsOfUsers.creditorContact[0]
          .countryCode,
      });
    }
    
    this.isFieldDisabled=true;
  }
  getUserDetails() {
    this.spinnerService.show();
    let path: string = 'user/GetUserProfileDetails?userid=' + this.userId;

    this.dataService.getRequest(path).subscribe((userResponse: any[]) => {
      
    this.spinnerService.hide();
      this.engagemetList = userResponse['userProfileList']['engagementDetails'];
      this.userContactList = userResponse['userProfileList']['userContact'];
      this.userAccount.firstName = userResponse['userProfileList']['userAccountDetails'].firstName;
      this.userAccount.lastName = userResponse['userProfileList']['userAccountDetails'].lastName;
      this.userAccount.emailAddress = userResponse['userProfileList']['userAccountDetails'].emailAddress;
      this.creditorContact.countryCode = userResponse['userProfileList']['CreditorContact'].countryCode;
      this.creditorContact.contactNumber = userResponse['userProfileList']['CreditorContact'].contactNumber;

    });
  }

  getUserRole() {
    this.userRole.roleName = this.dataService.userProfile.roleName;
      if (this.userRole.roleName == "Account Manager") {
        this.accountmanager = true
      }
      else {
        this.accountmanager = false
      }
   

  }
  getCreditorName(event) {
    //this.isActivatedUser=true;
    this.engagementId=event.value;
    this.isCreditorSelected=false;
    let path: string = 'user/GetCreditorsByEngagementId?engagementId=' + event.value+'&userId='+this.userId;
    this.spinnerService.show();
    
    this.dataService.getRequest(path).subscribe((userResponse: any[]) => {
      this.spinnerService.hide();
      this.creditorList = userResponse;
      this.isFieldDisabled=false;

    });
  }
  updateCreditorDeliveryMode() {
    if(this.deliveryModevalue)
    {
      this.spinnerService.show();
      let path: string = 'user/UpdateCreditorDeliveryMode?creditorid=' + this.creditorId+'&userId='+sessionStorage.getItem('userId');
      this.dataService.getRequest(path).subscribe((userResponse: any) => {
        this.spinnerService.hide();
      });
      this.floatMessage.showNotification("success", "Delivery mode has been successfully updated.");
      this.router.navigate(['creditorhome']);
    }
    else
      this.getUserDetails();    
  }
  getCreditorDetails(event) {
    //this.isActivatedUser=true;
    this.ngOnDestroy();
    this.isCreditorSelected=false;
    this.creditorId = event.value;
    
    // let path: string = 'user/GetUserDetails?userid=' +this.userId +
    // '&engagementId=' + this.engagementId + '&creditorId=' + this.creditorId;

    // this.dataService.getRequest(path).subscribe((userDetailsResponse: any) => {
    // this.userDetails = userDetailsResponse
    // if(this.userDetails.accountStatusId==1)
    // {
      let path: string = 'user/GetCreditorById?creditorid=' + event.value;
      this.spinnerService.show();
      this.dataService.getRequest(path).subscribe((userResponse: any) => {
      this.spinnerService.hide();
      this.creditordetails = userResponse;
      this.checkBoxProperty = this.samePostalMAilAddress(this.creditordetails);
      this.detailsOfUsers.claimantType = userResponse.claimantType;
      this.editLockedBy = userResponse.editLockedBy;
      
      this.editLock();
      if (this.detailsOfUsers.claimantType == ClaimantTypeEnum.IndividualEmployee || this.detailsOfUsers.claimantType == ClaimantTypeEnum.IndividualNonEmployee) {
        this.showIndividualForm = true;
        this.showCompanyForm = false;
      }
      else {
        this.showCompanyForm = true;
        this.showIndividualForm = false;
      }
      this.detailsOfUsers.creditorName=userResponse.creditorName;
      this.detailsOfUsers.firstName = userResponse.firstName;
      this.detailsOfUsers.lastName = userResponse.lastName;
      this.detailsOfUsers.postalAddressLine1 = userResponse.postalAddressLine1;
      this.detailsOfUsers.postalAddressLine2 = userResponse.postalAddressLine2;
      this.detailsOfUsers.postalAddressLine3 = userResponse.postalAddressLine3;
      this.detailsOfUsers.creditorUEN = userResponse.creditorUEN;
      this.detailsOfUsers.postalCountry = userResponse.postalCountry;
      this.detailsOfUsers.postalCode = userResponse.postalCode;
      this.detailsOfUsers.correspondenceMailingAddressLine1 = userResponse.correspondenceMailingAddressLine1;
      this.detailsOfUsers.correspondenceMailingAddressLine2 = userResponse.correspondenceMailingAddressLine2;
      this.detailsOfUsers.correspondenceMailingAddressLine3 = userResponse.correspondenceMailingAddressLine3;
      this.detailsOfUsers.correspondenceMailingCountry = userResponse.correspondenceMailingCountry;
      this.detailsOfUsers.correspondenceMailingPostalCode = userResponse.correspondenceMailingPostalCode;
      this.detailsOfUsers.emailAddress = userResponse.emailAddress;
      this.detailsOfUsers.iscorrespondenceSameAsPostal = userResponse.isCorrespondenceSameAsPostal;
      this.detailsOfUsers.nricfinPassportNo = userResponse.nricfinPassportNo;
      this.detailsOfUsers.creditorContact = userResponse.creditorContact;
      this.detailsOfUsers.countryCode = userResponse.countryCode;
      this.detailsOfUsers.contactNumber = userResponse.contactNumber;
      this.detailsOfUsers.deliveryMode = userResponse.deliveryMode;
      this.detailsOfUsers.creditorReferenceNumber = userResponse.creditorReferenceNumber;

      if (this.detailsOfUsers.deliveryMode == "Hard Copy") {
        this.hardcopy = true;
      }
      else {
        this.hardcopy = false;
      }
    //this.isActivatedUser=true;
    this.isCreditorSelected=true;
    });
  // }
  // else{
  //   this.isActivatedUser=false;
  // }
    
  // });
  
  }

  editLock(){
    this.iseditPage = true;
    
    
    if(this.editLockedBy == null){
      this.lockScreen = false;
      let lockDetails:any={
        lockId:this.creditorId,
        isScreenLock:true,
        module:'MyAccount'
      }
      this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
        //Logic to set timer for 20 minutes
        this.editLockTimer =  timer(this.fieldLength.MillisecondsPerMinute* parseInt(environment.editLockTimer),this.fieldLength.MillisecondsPerMinute)
        .subscribe(timerSubscription => {   
          let lockDetails:any={
            lockId:this.creditorId,
            isScreenLock:true,
            module:'MyAccount'
          }
          sessionStorage.setItem('isMyAccountEdit','true');
          this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
            if(response){}
          });
         });
        });
      
  
      sessionStorage.setItem('isMyAccountEdit','true');
      this.dataService.SetCreditorId(this.creditorId);
      }
      else
      this.toMapScreenLock();
  }
  toMapScreenLock() {
    if (this.editLockedBy != sessionStorage.getItem('userId')
      && this.editLockedBy != null) {
      this.lockScreen = true;
    }
  }
  samePostalMAilAddress(creditorDetails: any): boolean {
    var postal = [];
    postal.push(creditorDetails.postalAddressLine1);
    postal.push(creditorDetails.postalAddressLine2);
    postal.push(creditorDetails.postalAddressLine3);
    postal.push(creditorDetails.postalCode);
    postal.push(creditorDetails.postalCountry);
    var mailing = [];
    mailing.push(creditorDetails.correspondenceMailingAddressLine1);
    mailing.push(creditorDetails.correspondenceMailingAddressLine2);
    mailing.push(creditorDetails.correspondenceMailingAddressLine3);
    mailing.push(creditorDetails.correspondenceMailingPostalCode);
    mailing.push(creditorDetails.correspondenceMailingCountry);

    if (JSON.stringify(postal) == JSON.stringify(mailing)) {


      return true;
    }
    else {
      return false;
    }
  }

  public navigateToCreditorHome()
  {
    this.router.navigate(['creditorhome']);
  }
  showPopUp()
  {
    const dialogRef = this.dialog.open(DialogComponent, {
      disableClose: true,
      width: '500px',
      data: {
        twoButton: true,
        labelVal: "By clicking YES, your data will not be saved. Do you wish to proceed?",
        primaryButVal: 'YES',
        secondaryButVal: 'NO',
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.data == 'YES') {
        this.router.navigate(['creditorhome']);
      } 
    })
  }

  check(event) {
    if (event.checked === true) {
        this.deliveryModevalue = true;
        this.isSave=true
    }
    if (event.checked === false) {
      this.deliveryModevalue = false; 
      this.isSave=false;       
    }
}

ngOnDestroy(): void {
  if ( this.iseditPage && !this.lockScreen) {
    sessionStorage.setItem('isMyAccountEdit', 'false');
    let lockDetails: any = {
      lockId: this.creditorId,
      isScreenLock: false,
      module: 'MyAccount'
    }
    //Unsubscribe Edit lock timer
    this.unsubscribeEditLockTimer();

    this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
      this.dataService.emptyAdjudicationId();
    });
  }
}

unsubscribeEditLockTimer() {
  //logic to unsubscribe edit lock
  if (this.editLockTimer) {
    this.editLockTimer.unsubscribe();
  }
}
public doUnload(): void {
  this.doBeforeUnload();
}

public doBeforeUnload(): void {
  if (this.iseditPage && !this.lockScreen) {
  let lockDetails: any = {
    lockId: this.creditorId,
    isScreenLock: false,
    module: 'MyAccount'
  }
  this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
  });
}
}  
}
